export const comicCategories = [
  { slug: 'all', name: '全部', icon: 'ri-apps-line' },
  { slug: 'rexiaxuexiao', name: '热血', icon: 'ri-fire-line' },
  { slug: 'aichun', name: '恋爱', icon: 'ri-heart-line' },
  { slug: 'gaoji', name: '搞笑', icon: 'ri-emotion-laugh-line' },
  { slug: 'xuanhuan', name: '玄幻', icon: 'ri-magic-line' },
  { slug: 'maohan', name: '冒险', icon: 'ri-compass-line' },
  { slug: 'juqing', name: '剧情', icon: 'ri-book-open-line' },
  { slug: 'zhanji', name: '战斗', icon: 'ri-sword-line' },
  { slug: 'xuanwu', name: '悬疑', icon: 'ri-search-eye-line' },
  { slug: 'kongji', name: '恐怖', icon: 'ri-ghost-line' },
  { slug: 'kehuan', name: '科幻', icon: 'ri-rocket-line' },
  { slug: 'jichu', name: '竞技', icon: 'ri-trophy-line' },
  { slug: 'xiaohua', name: '校园', icon: 'ri-building-line' },
  { slug: 'dushi', name: '都市', icon: 'ri-building-2-line' },
];

export const comics = [
  {
    id: 1,
    title: '修罗武神',
    author: '善良的蜜蜂',
    category: 'xuanhuan',
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20manhua%20male%20protagonist%20martial%20arts%20cultivation%20epic%20fantasy%20cover%20art%2C%20dynamic%20pose%2C%20ancient%20Chinese%20warrior%20with%20flowing%20robes%2C%20dramatic%20lighting%2C%20vibrant%20red%20and%20gold%20accents%2C%20manga%20style%20illustration%2C%20clean%20simple%20background&width=600&height=800&seq=comic-cover-01&orientation=portrait',
    description: '楚枫凭借体内的九色神雷，一步步踏上武道巅峰，成为一代修罗武神。少年楚枫从一个被家族遗弃的废物，逆天改命，凭借神秘传承与坚韧意志，在强者如云的九州大陆书写传奇。',
    status: '连载中',
    rating: 9.5,
    views: '2.3亿',
    chapters: 1256,
    updatedAt: '2026-08-01',
    featured: true,
    tags: ['玄幻', '热血', '战斗', '逆袭'],
  },
  {
    id: 2,
    title: '斗破苍穹',
    author: '天蚕土豆',
    category: 'xuanhuan',
    cover: 'https://readdy.ai/api/search-image?query=manga%20cover%20art%20young%20male%20protagonist%20with%20flame%20powers%2C%20ancient%20Chinese%20fantasy%20setting%2C%20alchemy%20theme%2C%20dramatic%20orange%20and%20gold%20flames%2C%20martial%20arts%20cultivation%20style%2C%20clean%20composition%2C%20vibrant%20colors&width=600&height=800&seq=comic-cover-02&orientation=portrait',
    description: '天才少年萧炎在创造了家族空前绝后的修炼纪录后突然成了废人，在即将绝望之际，一缕幽魂从他手上的戒指里浮现，一扇全新的大门在面前开启。',
    status: '已完结',
    rating: 9.7,
    views: '5.1亿',
    chapters: 652,
    updatedAt: '2025-12-15',
    featured: true,
    tags: ['玄幻', '热血', '逆袭', '经典'],
  },
  {
    id: 3,
    title: '星辰变',
    author: '我吃西红柿',
    category: 'xuanhuan',
    cover: 'https://readdy.ai/api/search-image?query=manga%20cover%20art%20young%20male%20cultivator%20with%20star%20energy%2C%20cosmic%20theme%2C%20ancient%20Chinese%20fantasy%2C%20flowing%20silver%20hair%2C%20celestial%20atmosphere%2C%20purple%20and%20silver%20color%20scheme%2C%20clean%20simple%20background&width=600&height=800&seq=comic-cover-03&orientation=portrait',
    description: '秦羽天生无法修炼内功，为了得到父亲的重视，他毅然选择了修炼痛苦艰难的外功。一枚流星泪，改变了他的一生，从此踏上修真之路。',
    status: '已完结',
    rating: 9.4,
    views: '3.8亿',
    chapters: 486,
    updatedAt: '2025-10-20',
    featured: false,
    tags: ['玄幻', '修真', '热血'],
  },
  {
    id: 4,
    title: '完美世界',
    author: '辰东',
    category: 'xuanhuan',
    cover: 'https://readdy.ai/api/search-image?query=manga%20cover%20art%20young%20boy%20with%20primitive%20ancient%20powers%2C%20tribal%20themed%2C%20Chinese%20fantasy%20setting%2C%20beast%20companion%2C%20earth%20and%20nature%20elements%2C%20warm%20brown%20and%20green%20tones%2C%20epic%20scale&width=600&height=800&seq=comic-cover-04&orientation=portrait',
    description: '一粒尘可填海，一根草斩尽日月星辰。少年石昊从大荒中走出，一切从这里开始。上古重瞳、至尊骨，揭开了一个属于完美世界的神秘面纱。',
    status: '连载中',
    rating: 9.6,
    views: '4.2亿',
    chapters: 987,
    updatedAt: '2026-07-28',
    featured: true,
    tags: ['玄幻', '热血', '战斗', '史诗'],
  },
  {
    id: 5,
    title: '怦然心动',
    author: 'kid岁',
    category: 'aichun',
    cover: 'https://readdy.ai/api/search-image?query=manga%20cover%20art%20school%20romance%20cute%20girl%20and%20boy%20under%20cherry%20blossoms%2C%20spring%20theme%2C%20soft%20pink%20and%20white%20color%20palette%2C%20youth%20love%20story%2C%20shojo%20manga%20style%2C%20clean%20gentle%20background&width=600&height=800&seq=comic-cover-05&orientation=portrait',
    description: '狄淇儿与江应怜从小青梅竹马，从懵懂的青春到成熟的爱恋，一段怦然心动的校园爱情故事。纯真的感情在时光中慢慢发酵。',
    status: '连载中',
    rating: 9.2,
    views: '1.8亿',
    chapters: 520,
    updatedAt: '2026-07-30',
    featured: false,
    tags: ['恋爱', '校园', '青春', '甜宠'],
  },
  {
    id: 6,
    title: '狐妖小红娘',
    author: '小新',
    category: 'aichun',
    cover: 'https://readdy.ai/api/search-image?query=manga%20cover%20art%20beautiful%20fox%20spirit%20girl%20in%20traditional%20Chinese%20dress%2C%20romance%20fantasy%2C%20matchmaker%20theme%2C%20ancient%20Chinese%20setting%2C%20elegant%20flowing%20red%20and%20white%20robes%2C%20soft%20magical%20atmosphere&width=600&height=800&seq=comic-cover-06&orientation=portrait',
    description: '根据古典小说记载，世上有人有妖，妖会与人相恋。涂山狐妖一族以红娘为职业，帮助前世恋人在今生再续前缘。',
    status: '连载中',
    rating: 9.5,
    views: '3.2亿',
    chapters: 876,
    updatedAt: '2026-07-25',
    featured: true,
    tags: ['恋爱', '玄幻', '古风', '经典'],
  },
  {
    id: 7,
    title: '仙王的日常生活',
    author: '枯玄',
    category: 'gaoji',
    cover: 'https://readdy.ai/api/search-image?query=manga%20cover%20art%20comedy%20school%20life%20with%20superpowered%20student%2C%20funny%20expression%2C%20modern%20Chinese%20school%20uniform%2C%20magical%20elements%2C%20bright%20and%20cheerful%20colors%2C%20light%20hearted%20tone&width=600&height=800&seq=comic-cover-07&orientation=portrait',
    description: '王令是一名普通的高中生，但他有一个不普通的秘密——他是一位修为极高的仙王。为了过上平静的日常生活，他不得不隐藏自己的实力。',
    status: '连载中',
    rating: 9.0,
    views: '1.5亿',
    chapters: 420,
    updatedAt: '2026-07-29',
    featured: false,
    tags: ['搞笑', '校园', '玄幻', '日常'],
  },
  {
    id: 8,
    title: '一人之下',
    author: '米二',
    category: 'zhanji',
    cover: 'https://readdy.ai/api/search-image?query=manga%20cover%20art%20modern%20Chinese%20supernatural%20fighter%2C%20urban%20setting%2C%20martial%20arts%20action%2C%20mysterious%20power%2C%20dynamic%20battle%20pose%2C%20green%20and%20black%20color%20scheme%2C%20clean%20background&width=600&height=800&seq=comic-cover-08&orientation=portrait',
    description: '随着父亲失踪，神秘少女冯宝宝的造访，少年张楚岚的平静校园生活被彻底颠覆。一个关于异人的世界，在他面前徐徐展开。',
    status: '连载中',
    rating: 9.6,
    views: '4.5亿',
    chapters: 720,
    updatedAt: '2026-07-31',
    featured: true,
    tags: ['战斗', '都市', '悬疑', '热血'],
  },
  {
    id: 9,
    title: '吞噬星空',
    author: '我吃西红柿',
    category: 'kehuan',
    cover: 'https://readdy.ai/api/search-image?query=sci%20fi%20manga%20cover%20art%20futuristic%20warrior%20with%20mecha%20armor%2C%20space%20theme%2C%20alien%20monsters%2C%20cosmic%20background%2C%20silver%20and%20blue%20metallic%20tones%2C%20action%20pose%2C%20clean%20composition&width=600&height=800&seq=comic-cover-09&orientation=portrait',
    description: '大涅槃时期后，地球经历了一场浩劫。罗峰在逆境中崛起，一步步走出地球，走向浩瀚宇宙。人类、怪兽、宇宙强者，一场吞噬星空的传奇。',
    status: '已完结',
    rating: 9.3,
    views: '2.9亿',
    chapters: 560,
    updatedAt: '2025-08-10',
    featured: false,
    tags: ['科幻', '热血', '战斗', '末世'],
  },
  {
    id: 10,
    title: '大理寺日志',
    author: 'RC',
    category: 'xuanwu',
    cover: 'https://readdy.ai/api/search-image?query=manga%20cover%20art%20ancient%20Chinese%20detective%20mystery%2C%20Tang%20dynasty%20setting%2C%20cat%20official%20character%2C%20historical%20crime%20solving%2C%20warm%20autumn%20colors%2C%20clean%20composition%2C%20intriguing%20atmosphere&width=600&height=800&seq=comic-cover-10&orientation=portrait',
    description: '唐朝武周时期，大理寺少卿是一只白猫。新任少卿陈拾与这只猫大人一起，在大理寺中揭开一个个离奇案件背后的真相。',
    status: '连载中',
    rating: 9.4,
    views: '1.2亿',
    chapters: 340,
    updatedAt: '2026-07-20',
    featured: false,
    tags: ['悬疑', '古风', '搞笑', '探案'],
  },
  {
    id: 11,
    title: '百炼成神',
    author: '恩赐解脱',
    category: 'xuanhuan',
    cover: 'https://readdy.ai/api/search-image?query=manga%20cover%20art%20young%20male%20blacksmith%20cultivator%2C%20ancient%20Chinese%20fantasy%2C%20forging%20weapons%20theme%2C%20fiery%20forge%20background%2C%20muscular%20build%2C%20red%20and%20orange%20warm%20tones%2C%20clean%20composition&width=600&height=800&seq=comic-cover-11&orientation=portrait',
    description: '罗征从卑微的生者一步步成为绝世强者。以肉身为器，以天地为炉，百炼成神，踏碎凌霄。这是一个不屈少年的逆天之路。',
    status: '连载中',
    rating: 9.1,
    views: '1.9亿',
    chapters: 880,
    updatedAt: '2026-08-01',
    featured: false,
    tags: ['玄幻', '热血', '逆袭'],
  },
  {
    id: 12,
    title: '秦时明月',
    author: '温世仁',
    category: 'juqing',
    cover: 'https://readdy.ai/api/search-image?query=manga%20cover%20art%20ancient%20Chinese%20martial%20arts%20historical%20drama%2C%20Qin%20dynasty%20setting%2C%20swordsman%20in%20traditional%20robes%2C%20epic%20historical%20atmosphere%2C%20golden%20and%20crimson%20tones%2C%20clean%20composition&width=600&height=800&seq=comic-cover-12&orientation=portrait',
    description: '秦灭六国，天下初定。少年荆天明身世成谜，在乱世中与各路英雄相遇，揭开了一段波澜壮阔的秦代史诗。诸子百家，剑指天下。',
    status: '已完结',
    rating: 9.8,
    views: '6.3亿',
    chapters: 420,
    updatedAt: '2024-06-30',
    featured: true,
    tags: ['剧情', '历史', '武侠', '经典'],
  },
  {
    id: 13,
    title: '镇魂街',
    author: '许辰',
    category: 'zhanji',
    cover: 'https://readdy.ai/api/search-image?query=manga%20cover%20art%20supernatural%20guardian%20spirit%20warrior%2C%20modern%20urban%20fantasy%2C%20soul%20realm%20theme%2C%20dynamic%20action%20pose%2C%20dark%20and%20gold%20contrast%2C%20clean%20composition&width=600&height=800&seq=comic-cover-13&orientation=portrait',
    description: '镇魂街是人界通向灵域的重要通道。曹焱兵作为罗刹街的镇魂将，守护着这条街的秩序。寄灵人与守护灵，一场守护与战斗的传奇。',
    status: '连载中',
    rating: 9.5,
    views: '2.7亿',
    chapters: 580,
    updatedAt: '2026-07-22',
    featured: false,
    tags: ['战斗', '都市', '玄幻', '热血'],
  },
  {
    id: 14,
    title: '武动乾坤',
    author: '天蚕土豆',
    category: 'xuanhuan',
    cover: 'https://readdy.ai/api/search-image?query=manga%20cover%20art%20young%20male%20martial%20artist%20with%20ancient%20talisman%20powers%2C%20Chinese%20fantasy%2C%20meditation%20cultivation%20theme%2C%20flowing%20energy%2C%20teal%20and%20gold%20tones%2C%20clean%20composition&width=600&height=800&seq=comic-cover-14&orientation=portrait',
    description: '修炼一途，乃窃阴阳，夺造化。林动从青阳镇走出，凭借一枚神秘石符，在逆境中一步步踏上武道巅峰，武动乾坤。',
    status: '已完结',
    rating: 9.3,
    views: '3.5亿',
    chapters: 530,
    updatedAt: '2025-05-18',
    featured: false,
    tags: ['玄幻', '热血', '逆袭'],
  },
  {
    id: 15,
    title: '逆天邪神',
    author: '火星引力',
    category: 'xuanhuan',
    cover: 'https://readdy.ai/api/search-image?query=manga%20cover%20art%20vengeful%20male%20protagonist%20with%20dark%20powers%2C%20Chinese%20fantasy%2C%20reincarnation%20theme%2C%20dark%20and%20crimson%20atmosphere%2C%20mysterious%20aura%2C%20clean%20composition&width=600&height=800&seq=comic-cover-15&orientation=portrait',
    description: '云澈身负血海深仇，凭借逆天邪神之力重生归来。这一世，他要让所有敌人付出代价，踏上一条逆天而行的成神之路。',
    status: '连载中',
    rating: 9.4,
    views: '2.1亿',
    chapters: 960,
    updatedAt: '2026-07-30',
    featured: false,
    tags: ['玄幻', '热血', '逆袭', '复仇'],
  },
  {
    id: 16,
    title: '非人哉',
    author: '一汪空气',
    category: 'gaoji',
    cover: 'https://readdy.ai/api/search-image?query=manga%20cover%20art%20comedy%20mythological%20creatures%20in%20modern%20office%20life%2C%20Chinese%20gods%20and%20monsters%2C%20cute%20and%20funny%20style%2C%20bright%20colorful%20palette%2C%20light%20hearted%20tone%2C%20clean%20composition&width=600&height=800&seq=comic-cover-16&orientation=portrait',
    description: '九尾狐九月、龙二代敖烈、观音大士等神仙妖怪在现代都市的日常生活。当神话遇到职场，爆笑不断的神仙日常。',
    status: '连载中',
    rating: 9.3,
    views: '1.6亿',
    chapters: 680,
    updatedAt: '2026-07-28',
    featured: false,
    tags: ['搞笑', '日常', '神话', '轻松'],
  },
];

export const featuredComics = comics.filter(c => c.featured);
export const latestComics = [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime());
export const popularComics = [...comics].sort((a, b) => parseFloat(b.views.replace('亿', '')) - parseFloat(a.views.replace('亿', '')));
export const topRatedComics = [...comics].sort((a, b) => b.rating - a.rating);

export const getComicById = (id: number) => comics.find(c => c.id === id);
export const getComicsByCategory = (slug: string) => {
  if (slug === 'all') return comics;
  return comics.filter(c => c.category === slug);
};

export const bannerComics = comics.filter(c => c.featured).slice(0, 5);